"use client";

import { DynamicIcon } from "@/components/ui/DynamicIcon";
import { AnimatedStat } from "@/components/ui/AnimatedStat"; // YENİ EKLENDİ

interface AboutStatsProps {
    settings: any;
    statsData?: {
        title?: string;
        subtitle?: string;
        stats?: Array<{
            icon: string;
            value: string;
            label: string;
            suffix?: string;
            animation?: string; // YENİ EKLENDİ
        }>;
    };
}

export default function AboutStats({ settings, statsData }: AboutStatsProps) {
    // Eğer veritabanından istatistik verisi gelmediyse veya boşsa, boşluk yaratmaması için render etme
    if (!statsData || !statsData.stats || statsData.stats.length === 0) {
        return null;
    }

    // Dinamik Yıl Hesaplaması
    const establishmentYear = settings?.establishmentYear || 2020;
    const yearsOfExperience = new Date().getFullYear() - establishmentYear;

    // Başlığı parçalara ayırma (Ortadaki kelimeyi renklendirmek için)
    const title = statsData.title || "Başarı Hikayemiz Sayılarla";
    const titleWords = title.split(' ');
    const firstWord = titleWords[0] || "";
    const coloredWord = titleWords[1] || "";
    const restWords = titleWords.slice(2).join(' ');

    return (
        <section className="container mx-auto px-4 py-20 bg-white">
            <div className="text-center mb-16">
                <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                    {firstWord} <span style={{ color: 'var(--color-primary)' }}>{coloredWord}</span> {restWords}
                </h2>
                <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                    {statsData.subtitle || "Yıllar içinde elde ettiğimiz başarılar ve müşteri memnuniyeti odaklı yaklaşımımız"}
                </p>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
                {statsData.stats.map((stat, index) => {
                    // Eğer acente panelden değer olarak "YEARS" girmişse otomatik hesaplanan yılı bas
                    const baseValue = stat.value === "YEARS" ? `${yearsOfExperience}` : stat.value;

                    // AnimatedStat bileşeni birleştirilmiş metin formatını (Prefix + Num + Suffix) okuyup ayırabilir.
                    // Örneğin: "50000+" veya "%99" şeklinde tek parça gönderiyoruz.
                    const fullDisplayValue = `${baseValue}${stat.suffix || ""}`;

                    return (
                        <div
                            key={index}
                            className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 text-center hover:shadow-md transition-shadow group"
                        >
                            <div className="flex justify-center mb-4">
                                <div
                                    className="p-3 rounded-xl transition-colors duration-300"
                                    style={{
                                        backgroundColor: 'color-mix(in srgb, var(--color-primary), transparent 92%)'
                                    }}
                                >
                                    {/* String olarak gelen ikonu gerçek ikona çevir (Örn: "Users" -> <Users />) */}
                                    <DynamicIcon
                                        name={stat.icon || 'BarChart'}
                                        size={32}
                                        className="h-8 w-8"
                                        style={{ color: 'var(--color-primary)' }}
                                    />
                                </div>
                            </div>

                            {/* YENİ: ANİMASYONLU İSTATİSTİK BİLEŞENİ */}
                            <AnimatedStat
                                value={baseValue}
                                suffix={stat.suffix}
                                animation={stat.animation}
                                className="text-2xl lg:text-3xl font-bold text-gray-900 mb-1"
                                suffixStyle={{ color: 'var(--color-primary)' }}
                            />

                            <div className="text-gray-600 text-sm font-medium">{stat.label}</div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}